import type { IconSvgObject } from './types';

const ShadcnIcon: IconSvgObject = [
  ["path", { d: "M18 12L12 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 4L4 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ShadcnIcon;
